import { ReactNode, useEffect, useState } from "react";
import { MenuContext } from "./MenuContext";
import { MenuApiResponse, Menu } from "../helper/interface";
import { get } from "../helper/APIClient";
import { Routes } from "../helper/Routes";

interface Props {
  children: ReactNode;
}
export const MenuProvider = ({ children }: Props) => {
  const [menus, setMenus] = useState<Menu[]>([]);
  const [authorizedEndpoints, setAuthorizedEndpoints] = useState<string[]>([]);
  const [loading, setLoading] = useState(true); // ✅ START TRUE

  const hasAccess = (path: string): boolean => {
    const normalized = path.startsWith("/") ? path : `/${path}`;
    return authorizedEndpoints.includes(normalized);
  };

  const getMenus = async () => {
    try {
      const response: MenuApiResponse = await get(Routes.GET_USER_MENU);
      if (response.success) {
        setMenus(response.menus);
        setAuthorizedEndpoints(
          response.authorizedEndpoints.filter(p => !p.startsWith("/NoUrl"))
        );
      }
    } catch (error) {
      console.error("Menu fetch failed", error);
    } finally {
      setLoading(false); // ✅ ONLY after API finishes
    }
  };

  useEffect(() => {
    getMenus();
  }, []);

  return (
    <MenuContext.Provider value={{ menus, loading, hasAccess }}>
      {children}
    </MenuContext.Provider>
  );
};